<template>
  <div class="promote flex flex-y relative" v-bind:style="{ paddingTop }">
    <div class="width-full text-0 absolute" style="top: 0px">
      <img
        class="width-full"
        ref="custom"
        :src="require('@/assets/images/promote/custom/bg@2x.png') + `?timestamp=${new Date().valueOf()}`"
        alt="邀请车主奖13元现金"
        @load="handleContent"
      />
      <button class="absolute text-14 text-white" @click="handleRule">
        活动规则
      </button>
    </div>
    <div class="content text-14 text-white relative" style="z-index: 1">
      <template v-if="valid === 2">
        <div class="invite">
          <div class="flex flex-center">
            <div
              v-for="(item, index) in steps"
              :key="item.text"
              class="flex flex-y flex-center"
            >
              <div class="flex align-center margin-bottom-6">
                <img
                  v-if="index === 1"
                  class="margin-lr-20"
                  style="width: 22px; height: 22px"
                  src="@/assets/images/promote/custom/jiantou-2@2x.png"
                  alt=""
                />
                <img :src="item.img" :alt="item.text" />
                <img
                  v-if="index === 1"
                  class="margin-lr-20"
                  style="width: 22px; height: 22px"
                  src="@/assets/images/promote/custom/jiantou-2@2x.png"
                  alt=""
                />
              </div>
              <div class="text-13 text-white text-500">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <button @click="handleInvite" class="width-full text-0 flex">
          <img
            class="width-full"
            src="@/assets/images/promote/custom/btn@2x.png"
            alt="邀请好友"
          />
        </button>
        <div
          @click="handleQrcode"
          class="flex flex-center text-0"
          style="margin-top: 7px"
        >
          <div class="text-500 text-16" style="color: #fff4e8">面对面邀请</div>
          <img
            style="margin-left: 5px; height: 13px"
            src="@/assets/images/promote/custom/arrow-right-pinklight.png"
            alt=""
          />
        </div>
      </template>

      <template v-else>
        <img
          class="margin-top-36"
          v-if="valid === 0"
          src="~assets/images/promote/start.png"
          alt=""
          srcset=""
        />
        <img
          class="margin-top-36"
          v-if="valid === 1"
          src="~assets/images/promote/end.png"
          alt=""
          srcset=""
        />
      </template>
      <div class="coupon padding-bottom-2">
        <div class="coupon-top">
          <div class="flex padding-lr-16 align-center justify-between">
            <div class="text-17 text-500 text-16">我的奖励</div>
            <div
              v-if="!isMiniprogram"
              @click="goCoupons"
              class="bg-reddeep flex flex-center"
            >
              <div>去查看</div>
              <img src="@/assets/images/promote/custom/arrow-right.png" />
            </div>
          </div>
          <div
            class="flex margin-top-20 padding-bottom-8"
            v-bind:class="{ ['padding-bottom-20']: !users.length }"
          >
            <div
              v-for="item in bonus"
              :key="item.text"
              class="flex-1 flex flex-y flex-center"
            >
              <div class="margin-bottom-8">
                <span class="text-700">{{ item.num }}</span>
                {{ item.unit }}
              </div>
              <div class="flex flex-center text-12">
                {{ item.text }}
                <img
                  v-if="item.img"
                  @click="showTips"
                  style="width: 11px; margin-left: 2px"
                  src="@/assets/images/promote/wenhao@2x.png"
                  alt="提示"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="users.length" class="coupon-middle">
          <div></div>
        </div>
        <div v-if="users.length" class="coupon-bottom">
          <div class="padding-lr-16" style="color: #ffe0d4">
            <div class="margin-bottom-20" v-for="item in users" :key="item.id">
              <div class="flex align-center">
                <img
                  class="avatar margin-right-8"
                  src="@/assets/images/promote/avatar.png"
                  alt=""
                />
                <div class="flex-1">
                  <div class="text-14">{{ item.inviteeMobile }}</div>
                  <div class="text-11 margin-top-2">{{ item.createTime }}</div>
                </div>
                <div v-if="item.rewardStatus === 0" class="text-12">
                  <!-- 完成订单可得<br /><span class="text-16 text-500">10</span
                  >元优惠券 -->
                  在路上
                </div>
                <div v-if="item.rewardStatus === 2" class="text-12">
                  <!-- <span class="text-16 text-500">10</span>元优惠券 -->
                  已到账
                </div>
              </div>
            </div>
          </div>
          <div
            @click="handleRecord"
            class="padding-top-2 padding-bottom-22 flex flex-center"
          >
            <div style="color: #ffd9cb">查看完整邀请记录</div>
            <img
              class="arrow-right margin-left-4"
              src="@/assets/images/promote/arrow-right-pink.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <wx-mini-app-share :show.sync="showShare"></wx-mini-app-share>
  </div>
</template>

<script>
import invite from '@/assets/images/promote/custom/yaoqinghaoyou-2@2x.png'
import car from '@/assets/images/promote/custom/car@2x.png'
import bonus from '@/assets/images/promote/custom/bonus@2x.png'

import {
  getActivityInviteInfo,
  getActivityInfoById
} from '@/api/modules/promote'
import { handleApp, handleInvite } from '@/utils/handle_app'
import validActivity from '@/utils/valid_activity'
import WxMiniAppShare from 'cmp/share'

export default {
  components: {
    WxMiniAppShare
  },
  data () {
    return {
      showShare: false,
      paddingTop: '53.8793vh',
      bonus: [
        { num: 0, unit: '元', text: '累计获得' },
        { num: 0, unit: '人', text: '奖励在路上', img: 'wenhao@2x.png' },
        { num: 0, unit: '人', text: '成功邀请' }
      ],
      users: [],
      steps: [
        { text: '邀请好友', img: invite },
        { text: '好友领券&乘车', img: car },
        { text: '奖励到账', img: bonus }
      ],
      showAll: false,
      pageParams: {
        current: 1,
        size: 3,
        activityId: 212570000006
      },
      isMiniprogram: window.__wxjs_environment === 'miniprogram',
      valid: 2
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const { pageParams } = this

      getActivityInviteInfo(pageParams).then((data) => {
        this.bonus[0].num = data.sumBonus || 0
        this.bonus[1].num = data.partBountyCount
        this.bonus[2].num = data.allBountyCount

        const { records } = data.pageList

        this.users = records
      })
      getActivityInfoById(pageParams.activityId).then((res) => {
        const valid = validActivity(res.activityStartTime, res.activityEndTime)
        this.valid = valid
      })
    },
    showTips () {
      this.$dialog
        .alert({
          message: '邀请关系绑定成功，TA规定时间内完成首单，您可得奖励',
          theme: 'round-button',
          closeOnClickOverlay: true,
          confirmButtonText: '知道了'
        })
        .then(() => {
          // on close
        })
    },
    goCoupons () {
      handleApp('coupons')
    },
    toggleAll () {
      this.showAll = !this.showAll
    },
    handleRule () {
      this.$router.push('/agreement/detail/21165000000004')
    },
    handleInvite () {
      handleInvite('user', (params, flag) => {
        this.showShare = true
      })
    },
    handleQrcode () {
      this.$router.push('/promote/user/qrcode')
    },
    handleRecord () {
      this.$router.push('/promote/custom/record')
    },
    handleContent () {
      const height = this.$refs.custom.clientHeight

      this.paddingTop = Math.floor(height * 0.53 * 10000) / 10000 + 'px'
    },
    resizing () {
      this.ticking = false
      this.handleContent()
    },
    onResize () {
      if (!this.ticking) {
        window.requestAnimationFrame(this.resizing)
        this.ticking = true
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize, false)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize, false)
  }
}
</script>

<style lang="scss" scoped>
.promote {
  min-height: 100vh;
  overflow: hidden;
  background-color: #ff8500;

  button {
    padding: 0px;
    margin: 0px;
    outline: none;
    border: none;
    text-align: center;
    background-color: transparent;
  }

  .text-0 {
    font-size: 0px;
  }

  .text-500 {
    font-weight: 500;
  }

  .text-17 {
    font-size: 17px;
  }

  .text-11 {
    font-size: 11px;
    color: #ffaa93;
  }

  .text-700 {
    font-weight: 700;
    font-size: 25px;
    font-family: DIN Alternate, DIN Alternate-Bold;
  }

  img + button.absolute {
    width: 85px;
    height: 30px;
    right: 0px;
    top: 3.8177%;
    background-color: rgba(255, 255, 255, 0.22);
    border-radius: 15px 0px 0px 15px;
  }

  .content {
    padding: 10px 16px 40px;

    .invite {
      width: calc(100% + 6px);
      margin: 0px -3px;
      padding: 3px;
      position: relative;
      border-radius: 13px;
      background: linear-gradient(0deg, #ffab46 0%, #ffdfb1 100%);

      & > div {
        padding: 21px 0px 16px;
        border-radius: 13px;
        background: linear-gradient(180deg, #ff8502 0%, #ffab46 100%);
      }

      img {
        width: 50px;
        height: 50px;
      }
    }
    .bg-reddeep {
      width: 87px;
      height: 30px;
      border-radius: 15px;
      background-color: #f56200;

      img {
        width: 6px;
        height: auto;
        margin-left: 5px;
      }
    }
  }

  .coupon {
    margin-top: 21px;
    border-radius: 10px;
    overflow: hidden;
  }

  .coupon-top {
    padding-top: 23px;
    margin-bottom: -2px;
  }

  .coupon-top,
  .coupon-bottom {
    background-color: #ff7800;
  }

  .coupon-middle {
    height: 24px;
    position: relative;
    overflow: hidden;
  }
  .coupon-middle div {
    /* 中间虚线 */
    width: calc(100% - 12px);
    height: 24px;
    left: 6px;
    background-color: #ff7800;

    &,
    &:before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    &:before {
      content: "";
      display: block;
      width: 100%;
      left: 0px;
      border-top: 1px solid #f56200;
      z-index: 2;
    }
  }
  .coupon-middle:before,
  .coupon-middle:after {
    content: "";
    border: 12px solid #ff7800;
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
  }
  .coupon-middle:before {
    left: -18px;
  }
  .coupon-middle:after {
    right: -18px;
  }

  .coupon-bottom {
    margin-top: -2px;
    padding-top: 12px;

    .avatar {
      width: 35px;
      height: 35px;
      border-radius: 50%;
    }

    .arrow-right {
      width: 6px;
      height: 10px;
    }
  }
}
</style>
